<template>
  <v-card class="mb-2">
    <v-card-title class="font-weight-bold">经销商数量(按博世壁挂炉采购贡献划分)</v-card-title>
    <v-card-text>
      <v-chart
        v-if="data.length"
        autoresize
        :option="option"
        style="height: 250px"
      />
      <p v-else>没有数据！</p>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: ["data"],
  computed: {
    option() {
      return {
        textStyle: {
          fontFamily: 'Inter, "Helvetica Neue", Arial, sans-serif',
        },
        tooltip: {
          position: "bottom",
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)",
        },
        legend: {
          orient: "horizontal",
          left: "center",
          data: ["<20", "20-49", "50-99", ">=100"],
        },
        series: [
          {
            label: {
              formatter: '{c}(个)',
              minMargin: 5,
              edgeDistance: 10,
              lineHeight: 15,
              rich: {
                time: {
                  fontSize: 10,
                  color: '#999'
                }
              }
            },
            labelLine: {
              length: 15,
              length2: 0,
              maxSurfaceAngle: 80
            },
            name: "经销商数量",
            type: "pie",
            radius: "55%",
            center: ["50%", "60%"],
            data: this.data,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      };
    },
  },
  data: () => ({}),
};
</script>

<style lang="scss" scoped></style>
